import React from 'react';

const About = () => {
  return (
    <div>

        <div className="white-box">
            <h1>About the tool</h1>
            <div className="detailsection">
                <p>To provide parents and stakeholders with access to vital information on the physical state of more than 200 district-run schools, the Inquirer and Daily News created School Checkup.</p>
                <p>This one-of-a-kind tool blends six datasets. School Checkup is the culmination of months of research and analysis of more than 250,000 room-by-room environmental records that detail four building conditions known to impact a child&rsquo;s health: rampant mold, deteriorated asbestos, flaking and peeling lead paint, and drinking water containing high levels of lead.</p>
                <p>In many cases, the records expose filthy and unsafe conditions that have manifested repeatedly in the district&rsquo;s aging buildings.</p>
                <p>Combining public and internal district records, School Checkup identifies schools with recently damaged asbestos in classrooms, gymnasiums and other areas occupied by students and staff. The data include federally required asbestos inspections compiled during the 2015-16 school year as well as maintenance records from mid-2015 to April 2018.</p>
                <p>For schools built before the 1978 lead-paint ban, we analyzed more than three years of data to pinpoint damaged paint and plaster, assumed to contain lead. It was obtained through a public records request. The data gives parents a look at classrooms with recent paint damage at more than 150 schools.</p>
                <p>School Checkup is also built on district environmental maintenance records that identify known asthma triggers: mold, poor ventilation, rodent droppings and cockroach infestations. It also includes hundreds of Philadelphia health-department inspections since 2017 that show chronic problems with rodents and cockroaches in many schools.</p>
                <p>The checkup tool also includes the district&rsquo;s most recent water-testing reports for more than 4,500 fountains, sinks and other outlets that showed unhealthy levels of lead.</p>

            </div>
        </div>
    </div>
  );
}

export default About;



// WEBPACK FOOTER //
// ./src/routes/About.js